import { Component, Vue, Prop as prop} from 'nuxt-property-decorator';

@Component
export default class TooltipComponent extends Vue {

    @prop({type: Boolean})
    public active: boolean;
}
